{
	"title": "Тесты",
	"list": {
		"title": "Все тесты",
		"subtitle": "{count, plural, one {# тест} few {# теста} other {# тестов}}",
		"empty": "Пока нет тестов",
		"emptyDescription": "Сгенерируй тест из материала или по экзамену — AI подберёт нужные типы вопросов и уровень сложности.",
		"create": "Сгенерировать",
		"createEmpty": "Создать пустой",
		"createEmptyAction": "Создать тест",
		"createEmptyTitle": "Создать пустой тест",
		"errorTitle": "Не удалось загрузить тесты",
		"errorDescription": "Проверь соединение или повтори запрос.",
		"retry": "Повторить",
		"averageScore": "средний балл {percent}%",
		"search": "Поиск тестов...",
		"filterMaterial": "Материал",
		"filterPreset": "Экзамен",
		"filterSort": "Сортировка",
		"sortByUpdated": "По дате",
		"sortByName": "По алфавиту",
		"sortByScore": "По результату",
		"viewGrid": "Сетка",
		"viewList": "Список",
		"showMore": "Показать ещё",
		"filters": "Фильтры",
		"filtersTitle": "Фильтры",
		"delete": "Удалить",
		"play": "Пройти",
		"start": "Начать",
		"continue": "Продолжить",
		"questionsCount": "{count, plural, one {# вопрос} few {# вопроса} other {# вопросов}}",
		"attemptsCount": "{count, plural, one {# попытка} few {# попытки} other {# попыток}}",
		"lastScore": "последний {percent}%",
		"fromMaterial": "Из материала «{name}»",
		"fromChat": "Из чата «{name}»",
		"averageBadge": "средний {percent}%",
		"generationProgress": "Генерация — {percent}%",
		"stage": "стадия: {stage}",
		"deletedToast": "Перемещено в корзину"
	},
	"edit": {
		"title": "Редактор теста",
		"backToList": "К списку",
		"metadata": "Метаданные",
		"questions": "Вопросы",
		"saveChanges": "Сохранить",
		"addQuestion": "Добавить вопрос",
		"deleteQuestion": "Удалить вопрос",
		"editQuestion": "Редактировать",
		"questionText": "Текст вопроса",
		"correctAnswer": "Правильный ответ",
		"explanation": "Объяснение",
		"topic": "Тема",
		"difficulty": "Сложность",
		"difficultyEasy": "Лёгкий",
		"difficultyMedium": "Средний",
		"difficultyHard": "Сложный",
		"addOption": "Добавить вариант",
		"removeOption": "Удалить",
		"nameLabel": "Название теста",
		"descriptionLabel": "Описание",
		"timeLimitLabel": "Лимит времени (мин), 0 = без лимита",
		"passingScoreLabel": "Проходной балл (%)",
		"examPresetLabel": "Экзамен",
		"noQuestions": "Нет вопросов. Добавь первый.",
		"saved": "Сохранено",
		"generating": "Генерация…",
		"generatingTitle": "AI генерирует вопросы…",
		"generatingHint": "Обычно занимает 20–40 секунд. Страница обновится сама.",
		"generationFailedTitle": "Не удалось сгенерировать тест",
		"generationFailedHint": "Попробуйте сгенерировать заново или добавьте вопросы вручную.",
		"deleteConfirm": "Удалить этот вопрос?",
		"deleteTitle": "Удалить вопрос?",
		"deleteDescription": "Это действие нельзя отменить. Вопрос будет удалён из теста.",
		"deleteAction": "Удалить",
		"deleteCancel": "Отмена"
	},
	"questionTypes": {
		"single": "Один правильный",
		"multiple": "Несколько правильных",
		"true-false": "Верно / Неверно",
		"short-answer": "Короткий ответ",
		"fill-blank": "Пропуск в тексте",
		"free-answer": "Развёрнутый ответ",
		"multi-layered-passage": "Многоуровневый текст",
		"multipleChoice": "Выбор одного",
		"multipleAnswer": "Выбор нескольких",
		"trueFalse": "Верно / Неверно",
		"shortAnswer": "Короткий ответ",
		"essay": "Эссе",
		"matching": "Сопоставление",
		"multiLayeredPassage": "Многоуровневый текст"
	},
	"take": {
		"exit": "Выйти",
		"exitConfirmTitle": "Выйти из теста?",
		"exitConfirmDescription": "Прогресс сохраняется автоматически. Ты сможешь продолжить с этого же места.",
		"exitConfirm": "Выйти",
		"cancel": "Отмена",
		"progress": "{current} из {total}",
		"next": "Дальше",
		"previous": "Назад",
		"submit": "Завершить",
		"submitError": "Не удалось отправить ответы",
		"submitConfirmTitle": "Завершить тест?",
		"submitConfirmDescription": "После завершения изменить ответы будет нельзя.",
		"loadingTest": "Загружаем тест…",
		"loadFailedTitle": "Не удалось запустить тест",
		"loadFailedDescription": "Проверьте подключение к сети и повторите попытку.",
		"offlineTitle": "Тест недоступен в офлайн-режиме",
		"offlineDescription": "Этот тест ещё не синхронизирован или не содержит вопросов. Подключитесь к сети, чтобы загрузить его — после этого вы сможете проходить его офлайн.",
		"retry": "Повторить",
		"retrying": "Переподключаемся…",
		"paywallTitle": "Требуется Plus",
		"paywallDescription": "Лимит бесплатных тестов исчерпан.",
		"paywallCta": "Перейти на Plus",
		"timeUp": "Время вышло",
		"timeUpDescription": "Твои ответы сохранены автоматически.",
		"viewResults": "Посмотреть результаты",
		"selectAnswer": "Выбери вариант",
		"selectAnswers": "Выбери несколько вариантов",
		"typeAnswer": "Введи ответ",
		"writeAnswer": "Напиши ответ",
		"fillBlanks": "Заполни пропуски",
		"charCount": "{used} / {max}",
		"wordCount": "{count, plural, one {# слово} few {# слова} other {# слов}}",
		"subQuestion": "Подвопрос {idx} из {total}",
		"gradingTitle": "Проверяем ответы…",
		"gradingDescription": "AI оценивает развёрнутые ответы. Это займёт меньше минуты.",
		"dontKnow": "Не знаю",
		"selectMultiple": "Выберите один или несколько вариантов",
		"trueOption": "Верно",
		"falseOption": "Неверно",
		"correctTitle": "Верно!",
		"incorrectTitle": "Продолжай практиковаться",
		"partialTitle": "Частично верно",
		"pendingReviewTitle": "Ответ на проверке",
		"checkingTitle": "Проверяем ответ…",
		"aiFeedbackTitle": "Комментарий AI",
		"gradeDeferredNote": "Не удалось проверить сейчас — AI проверит этот ответ после завершения теста.",
		"explanationTitle": "Объяснение",
		"navigatorTitle": "Вопросы",
		"navigatorOpen": "Все вопросы",
		"navigatorAnswered": "Отвечено",
		"navigatorCurrent": "Текущий",
		"navigatorUnanswered": "Не отвечен",
		"jumpToQuestion": "Перейти к вопросу {number}",
		"questionLabel": "Вопрос {number}",
		"timerLabel": "Осталось времени",
		"finish": "Завершить тест",
		"finishHint": "Все вопросы пройдены",
		"hintChoose": "выбор",
		"hintConfidence": "уверенность",
		"hintNext": "дальше",
		"hintAnswer": "ответить",
		"hintExit": "выйти",
		"submitOfflineTitle": "Нет соединения — оценка пока невозможна",
		"submitOfflineDescription": "Ваши ответы сохранены на этом устройстве. Отправьте их повторно, когда появится подключение к сети.",
		"questionOfTotal": "Вопрос {number} из {total}",
		"limitTitle": "Лимит тестов исчерпан",
		"limitDescription": "Новые тесты сейчас начать нельзя. Пройденные тесты остаются доступны."
	},
	"confidence": {
		"title": "Насколько уверен в ответе?",
		"not-confident": "Не уверен",
		"unsure": "Сомневаюсь",
		"confident": "Уверен",
		"low": "Не уверен",
		"medium": "Сомневаюсь",
		"high": "Уверен",
		"veryLow": "Не уверен"
	},
	"results": {
		"title": "Результаты",
		"matrix": {
			"title": "Уверенность × правильность",
			"subtitle": "Где есть критические пробелы и удачи",
			"axis": {
				"correct": "Верно",
				"wrong": "Неверно"
			},
			"cell": {
				"mastery": "Освоено",
				"critical": "Критический пробел",
				"softMastery": "Скорее освоено",
				"expected": "Ожидаемо",
				"lucky": "Случайно угадано",
				"acknowledged": "Признанный пробел"
			},
			"drillDown": "{count, plural, one {# вопрос} few {# вопроса} other {# вопросов}}",
			"yourAnswer": "Твой ответ",
			"empty": "Нет вопросов в этой категории"
		},
		"score": "{correct} из {total}",
		"percentage": "{percent}%",
		"passed": "Сдано",
		"failed": "Не сдано",
		"reviewAnswers": "Разобрать ответы",
		"retake": "Пройти заново",
		"backToTest": "К тестам",
		"backToTopic": "Вернуться к теме",
		"retry": "Повторить",
		"duration": "Время прохождения: {time}",
		"breakdownTitle": "Разбор по темам",
		"topicHeader": "Тема",
		"totalHeader": "Всего",
		"correctHeader": "Верно",
		"accuracyHeader": "Точность",
		"weakHeader": "Уверен + неверно",
		"questionsTitle": "Вопросы",
		"correct": "Верно",
		"partial": "Частично верно",
		"wrong": "Неверно",
		"skipped": "Пропущено",
		"yourAnswer": "Твой ответ",
		"correctAnswer": "Правильный ответ",
		"explanation": "Объяснение",
		"aiGraded": "Оценено AI",
		"aiScore": "Балл AI: {score}",
		"aiFeedback": "Фидбек AI",
		"dispute": "Оспорить",
		"weakSpotsBanner": "Найдены слабые темы — посмотри рекомендации",
		"viewWeakSpots": "Открыть слабые места",
		"scoreLabel": "Результат",
		"correctOf": "{correct} из {total} верно",
		"nextStepsTitle": "Что дальше",
		"nextStepRetake": "Пройти тест заново",
		"nextStepRetakeDesc": "Закрепи материал — попробуй снова с этими же вопросами",
		"nextStepWeakSpots": "Разобрать слабые места",
		"nextStepWeakSpotsDesc": "AI нашёл темы с пробелами — создай по ним карточки и тесты",
		"nextStepReview": "Перечитать материал",
		"nextStepReviewDesc": "Вернись к конспекту и закрой пробелы перед следующей попыткой",
		"nextStepDone": "Отличный результат",
		"nextStepDoneDesc": "Ты уверенно прошёл тест — двигайся к следующей теме",
		"questionFilterAll": "Все",
		"questionFilterWrong": "Ошибки",
		"questionFilterFlagged": "Под вопросом",
		"questionsCountLabel": "{count, plural, one {# вопрос} few {# вопроса} other {# вопросов}}",
		"noQuestionsInFilter": "Нет вопросов в этой категории",
		"pendingGrading": "Ожидает проверки AI"
	},
	"generate": {
		"title": "Сгенерировать тест",
		"subtitle": "AI создаст вопросы на основе материала, темы или экзамена",
		"sourceMaterial": "По материалу",
		"sourceTopic": "По теме",
		"sourcePreset": "По экзамену",
		"materialPlaceholder": "Выбери материал",
		"topicPlaceholder": "Например: митоз и мейоз",
		"countLabel": "Количество вопросов: {count}",
		"difficultyLabel": "Сложность",
		"difficultyMixed": "Микс",
		"typesLabel": "Типы вопросов",
		"generate": "Сгенерировать",
		"cancel": "Отмена",
		"queued": "Тест в очереди — придёт уведомление, когда будет готов"
	},
	"preset": {
		"title": "Выбор экзамена",
		"search": "Поиск экзамена...",
		"groupRU": "Россия",
		"groupUS": "США",
		"groupUK": "Великобритания",
		"groupInternational": "Международные",
		"groupOther": "Другое",
		"select": "Выбрать",
		"empty": "Ничего не найдено"
	},
	"resume": {
		"title": "Продолжить тест?",
		"description": "У тебя есть незавершённая попытка от {date}. Хочешь продолжить с прежнего места или начать заново?",
		"continue": "Продолжить",
		"restart": "Начать заново"
	},
	"dispute": {
		"title": "Оспорить оценку",
		"description": "Опиши, почему считаешь оценку несправедливой. AI пересчитает результат с учётом твоих аргументов.",
		"reasonLabel": "Причина",
		"reasonPlaceholder": "Например: ответ полностью раскрывает определение, но AI не учёл синонимы",
		"submit": "Отправить",
		"cancel": "Отмена",
		"submitted": "Запрос принят"
	},
	"examPresets": {
		"title": "Шаблоны экзаменов",
		"custom": "Свой формат",
		"none": "Без экзамена"
	},
	"presets": {
		"ege-math-base": "ЕГЭ Математика (база)",
		"ege-math-profile": "ЕГЭ Математика (профиль)",
		"ege-physics": "ЕГЭ Физика",
		"ege-chemistry": "ЕГЭ Химия",
		"ege-biology": "ЕГЭ Биология",
		"ege-russian": "ЕГЭ Русский",
		"ege-english": "ЕГЭ Английский",
		"ege-history": "ЕГЭ История",
		"ege-social-studies": "ЕГЭ Обществознание",
		"ege-literature": "ЕГЭ Литература",
		"ege-informatics": "ЕГЭ Информатика",
		"oge-math": "ОГЭ Математика",
		"oge-russian": "ОГЭ Русский",
		"oge-english": "ОГЭ Английский",
		"vpr-grade-4": "ВПР 4 класс",
		"vpr-grade-5": "ВПР 5 класс",
		"vpr-grade-6": "ВПР 6 класс",
		"vpr-grade-7": "ВПР 7 класс",
		"vpr-grade-8": "ВПР 8 класс",
		"vpr-grade-11": "ВПР 11 класс",
		"sat-math": "SAT Math",
		"sat-evidence-based-reading": "SAT Reading",
		"ap-calculus": "AP Calculus",
		"ap-physics": "AP Physics",
		"ap-chemistry": "AP Chemistry",
		"ap-biology": "AP Biology",
		"ap-history": "AP History",
		"mcat": "MCAT",
		"usmle-step-1": "USMLE Step 1",
		"usmle-step-2": "USMLE Step 2",
		"nclex": "NCLEX",
		"gre": "GRE",
		"gmat": "GMAT",
		"lsat": "LSAT",
		"gcse-math": "GCSE Math",
		"gcse-english": "GCSE English",
		"a-levels-math": "A-Levels Math",
		"a-levels-physics": "A-Levels Physics",
		"ielts-listening": "IELTS Listening",
		"ielts-reading": "IELTS Reading",
		"ielts-writing": "IELTS Writing",
		"ielts-speaking": "IELTS Speaking",
		"toefl-reading": "TOEFL Reading",
		"toefl-listening": "TOEFL Listening",
		"toefl-writing": "TOEFL Writing",
		"toefl-speaking": "TOEFL Speaking",
		"none": "Без экзамена",
		"custom": "Свой формат"
	},
	"intro": {
		"title": "Что тест даёт, кроме балла",
		"body": "Вместе с результатом — разбор по темам: где ошиблись уверенно, а где угадали. Из этого сама собирается карта слабых мест.",
		"bullets": [
			"Семь типов вопросов, включая развёрнутый ответ",
			"Уверенность отмечаете вы — уверенная ошибка важнее",
			"Попытку можно прервать и продолжить с того же места"
		]
	}
}
